import { createReducer, on, type Action } from '@ngrx/store';

import {
  setMGMCustomerDetails,
  setMGMSaleIdAction,
} from './member-get-member-state.actions';

export interface MemberGetMemberState {
  saleId?: string;
  customerName?: string;
  customerEmail?: string;
}

const _reducer = createReducer(
  {},
  on(setMGMSaleIdAction, (state, { saleId }) => ({ ...state, saleId })),
  on(setMGMCustomerDetails, (state, { customerName, customerEmail }) => ({
    ...state,
    customerName,
    customerEmail,
  }))
);

export function memberGetMemberReducer(
  state: MemberGetMemberState = {},
  action: Action
): MemberGetMemberState {
  return _reducer(state, action);
}
